var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"right-box",attrs:{"id":"right-box-content"}},[_c('News'),_c('Tour'),_c('HotTv'),_c('HotBuy'),_c('li',{staticClass:"right-box-bottom-helper",attrs:{"id":"right-box-bottom-helper"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }